/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateJobBatchRequest {
    getFixupPrototypeFunction() { return TemplateJobBatchRequest.fixupPrototype; }

    static newInstance(model: Partial<TemplateJobBatchRequest>): TemplateJobBatchRequest {
        let obj = Object.assign(new TemplateJobBatchRequest(), model);
        TemplateJobBatchRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateJobBatchRequest>): TemplateJobBatchRequest {
        if (!model) return null;
        return TemplateJobBatchRequest.newInstance(<TemplateJobBatchRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateJobBatchRequest) {
        if (!obj) return;

        models.TemplateJobBatchRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateJobBatchRequest): boolean {
        Object.setPrototypeOf(obj, TemplateJobBatchRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Template job IDs to fetch full details for
     */
    job_ids: Array<string>;

}
